(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('EditStaffUserController', EditStaffUserController);

  /* ngInject */
  function EditStaffUserController($state, $stateParams, Flash, formErrorsService, staffProductRoleService, productService, sessionService, staffService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.activate = activate;
    vm.deleteStaffUser = deleteStaffUser;
    vm.getProducts = getProducts;
    vm.getStaffUser = getStaffUser;
    vm.getUserProductRoles = getUserProductRoles;
    vm.products = [];
    vm.saveStaffUser = saveStaffUser;
    vm.saveUserProductRoles = saveUserProductRoles;
    vm.staffUser = {};
    vm.staffUserForm = {};
    vm.userProductRoles = {};

    vm.activate();

    function activate() {
      vm.getProducts();
      vm.getStaffUser();
      vm.getUserProductRoles();
    }

    function deleteStaffUser() {
      vm.clearFormErrors(vm.userForm);
      staffService(sessionService.getAuthToken()).destroy({id: $stateParams.id});
      $state.go('application.compliance_framework.staff');
    }

    function getProducts() {
      productService(sessionService.getAuthToken()).query(response => {
        vm.products = response;
      });
    }

    function getStaffUser() {
      staffService(sessionService.getAuthToken()).get({id: $stateParams.id}, response => {
        vm.staffUser = response;
      });
    }

    function getUserProductRoles() {
      staffProductRoleService(sessionService.getAuthToken()).query({staffUserId: $stateParams.id}, response => {
        response.forEach(productRole => {
          if (!vm.userProductRoles[productRole.product_id]) {
            vm.userProductRoles[productRole.product_id] = [productRole.role_id];
          } else {
            vm.userProductRoles[productRole.product_id].push(productRole.role_id);
          }
        });
      });
    }

    function saveStaffUser(staff) {
      staffService(sessionService.getAuthToken()).update({id: $stateParams.id, staff}, _updateUserSuccess, _saveUserFailure);
    }

    function saveUserProductRoles() {
      let roleIds = [];
      for (let productId in vm.userProductRoles) {
        for (let roleId of vm.userProductRoles[productId]) {
          roleIds.push(roleId);
        }
      }

      staffProductRoleService(sessionService.getAuthToken()).save({staffUserId: $stateParams.id, role_ids: roleIds}, _saveUserProductRolesSuccess);
    }

    function _saveUserProductRolesSuccess(_response) {
      Flash.create('success', 'The user roles were successfully updated.');
    }

    function _updateUserSuccess(_response) {
      Flash.create('success', 'The user was successfully updated.');
    }

    function _saveUserFailure(response) {
      vm.setFormErrors(vm.form, response);
      Flash.create('success', 'An error occurred with the submission. Please correct the errors on the form and resubmit.');
    }
  }
})();
